export const configApi = {
	apiUrl: 'https://api.ticketshopve.com/api/' // Servidor Final 	
};